// src/com/veh_banning/VehBanningGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * VEH_BANNING Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-09-30 17:06:03 using DbdbTap
 ************************************************ */

const VEH_BANNING_LIST_PART = gql`
fragment VehBanningListPart on VehBanning {
    vehInfoSeq
    comId
    vehDcCd
    vehDcName
    comName
    vehPlates
    driverName
    driverMobile
    useCvo
    useCvoLabel
    dcCd
    dcName
    vehBanFlag
    vehBanLabel
    vehBanPeriod
    vehBanLastingFlag
    vehBanStartTime
    vehBanEndTime
    vehBanDays
    regDate
    regUser
    regUserName
}
`;

export const LIST_VEH_BANNING = gql`
${VEH_BANNING_LIST_PART}
query ListVehBanning($comId: String) {
    vehBanningList(comId: $comId) {
        ...VehBanningListPart
    }
}
`;

export const LIST_NOT_BANNED_VEH_BANNING = gql`
${VEH_BANNING_LIST_PART}
query ListNotBannedVehBanning($comId: String) {
    vehBanningListNotBanned(comId: $comId) {
        ...VehBanningListPart
    }
}
`;

export const GET_VEH_BANNING = gql`
${VEH_BANNING_LIST_PART}
query GetVehBanning($vehInfoSeq: Int!) {
    vehBanningItem(vehInfoSeq: $vehInfoSeq) {
        ...VehBanningListPart
    }
}
`;

